import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useSamplesModalStore, useAuthModalStore, useLightboxStore } from "@/stores/ui";

// 12 curated samples drawn from the 30 committed style previews under
// apps/web/public/styles/ (served by the API at the same path).
const SAMPLES: Array<[string, string]> = [
  ["stl_realistic", "写实"],
  ["stl_cinematic", "电影感"],
  ["stl_editorial", "杂志大片"],
  ["stl_bw_film", "黑白胶片"],
  ["stl_anime", "日系动漫"],
  ["stl_watercolor", "水彩"],
  ["stl_oil_painting", "油画"],
  ["stl_ink_wash", "国风水墨"],
  ["stl_cyberpunk", "赛博朋克"],
  ["stl_concept_art", "概念艺术"],
  ["stl_3d_render", "3D 渲染"],
  ["stl_minimal", "极简"],
];

export function SamplesModal() {
  const open = useSamplesModalStore((s) => s.open);
  const hide = useSamplesModalStore((s) => s.hide);
  const openAuth = useAuthModalStore((s) => s.openAt);
  const showLightbox = useLightboxStore((s) => s.show);

  return (
    <Dialog open={open} onOpenChange={(v) => !v && hide()}>
      <DialogContent className="grid max-h-[88vh] max-w-[min(1100px,92vw)] grid-rows-[auto_minmax(0,1fr)_auto] gap-0 p-0">
        <header className="flex items-start justify-between gap-4 border-b border-border px-6 py-5">
          <div className="flex flex-col gap-1">
            <DialogTitle>样片精选</DialogTitle>
            <DialogDescription>
              同一段描述，30 种风格的真实生成结果。
            </DialogDescription>
          </div>
        </header>

        <div className="grid grid-cols-[repeat(auto-fill,minmax(180px,1fr))] gap-3 overflow-y-auto px-6 py-5">
          {SAMPLES.map(([id, label]) => (
            <figure
              key={id}
              className="group relative m-0 cursor-zoom-in overflow-hidden rounded-md border border-border bg-card transition-all hover:-translate-y-0.5 hover:border-accent"
              onClick={() => showLightbox(`/styles/${id}.jpg`)}
            >
              <img
                src={`/styles/${id}.jpg`}
                alt={label}
                loading="lazy"
                className="aspect-square w-full object-cover"
                onError={(e) => {
                  (e.currentTarget.parentElement as HTMLElement).style.display = "none";
                }}
              />
              <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent px-2.5 py-1.5 text-xs font-semibold text-foreground">
                {label}
              </figcaption>
            </figure>
          ))}
        </div>

        <footer className="flex justify-end border-t border-border px-6 py-4">
          <Button
            onClick={() => {
              hide();
              openAuth("login");
            }}
          >
            登录后使用
          </Button>
        </footer>
      </DialogContent>
    </Dialog>
  );
}
